export enum NotificationEventsEnum {
	NotificationCreated = 'notification.created',
	NotificationRead = 'notification.read',
	NotificationDeleted = 'notification.deleted',

	NotificationCreatedMultiple = 'notification.created_multiple',
	NotificationReadMultiple = 'notification.read_multiple',
	NotificationDeletedMultiple = 'notification.deleted_multiple'
}
